import { render, staticRenderFns } from "./PreguntasComponent.vue?vue&type=template&id=7b0b8063&scoped=true"
import script from "./PreguntasComponent.vue?vue&type=script&lang=js"
export * from "./PreguntasComponent.vue?vue&type=script&lang=js"
import style0 from "./PreguntasComponent.vue?vue&type=style&index=0&id=7b0b8063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0b8063",
  null
  
)

export default component.exports